import { createSelector } from 'reselect';

export const errorSelector = createSelector(
  (state) => state.errorHandle,
  (errorHandle) => errorHandle
);
